const resultsBtn = document.getElementById("results-btn");
const questionContainers = document.querySelectorAll(".question-container");

resultsBtn.addEventListener("click", () => {
  const name = document.getElementById("client-name").value;
  const phone = document.getElementById("client-phone").value;
  const email = document.getElementById("client-email").value;

  // check if email is valid
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isEmailValid = emailRegex.test(email);

  if (!isEmailValid) {
    alert("من فضلك أدخل بريد إلكتروني صحيح");
    return;
  }

  if (
    name === "" ||
    phone === "" ||
    email === "" ||
    !name ||
    !phone ||
    !email
  ) {
    alert("من فضلك أدخل كل الحقول");
    return;
  }

  const info = {
    name,
    phone,
    email,
  };

  localStorage.setItem("info", JSON.stringify(info));

  const answers = [];

  questionContainers.forEach((container, index) => {
    const radioButtons = container.querySelectorAll(
      `input[name="answer-${index + 1}"]`
    );

    let selectedValue = null;

    radioButtons.forEach((radio) => {
      if (radio.checked) {
        selectedValue = radio.value;
        answers.push(selectedValue);
      }
    });
  });

  if (answers.length === questionContainers.length) {
    console.log("All questions answered. Answers:", answers);
    localStorage.setItem("data", JSON.stringify(answers));

    window.location.href = window.location.origin + "/results.html";
  } else {
    alert("من فضلك أدخل كل الحقول");
  }
});
